/** Shared chrome header height — SiteHeader and Hermes drawer top bar. */
export const SHELL_HEADER_CLASS = "flex h-16 shrink-0 items-center border-b";
